import React from "react";
import { ToggleButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { StyledToggleButtonGroup } from "./ToggleGroup.styled";

const ToggleGroup = ({ items = [], onChange, defaultPath = "", basePath = "" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [selected, setSelected] = React.useState(() => {
    if (!items || items.length === 0) return "";
    
    const currentPath = location.pathname;
    const matchedItem = items.find((item) =>
      currentPath.includes(item.path || item.value)
    );
    return matchedItem ? matchedItem.value : items[0]?.value || "";
  });

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      setSelected(newValue);
      const selectedItem = items?.find((item) => item.value === newValue);
      const path = selectedItem?.path || selectedItem?.value;
      navigate(basePath ? `${basePath}/${path}` : path);
      if (onChange) {
        onChange(newValue);
      }
    }
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <StyledToggleButtonGroup
      value={selected}
      exclusive
      onChange={handleChange}
      aria-label="navigation toggle"
      size="small"
    >
      {items.map((item) => (
        <ToggleButton
          key={item.value}
          value={item.value}
          aria-label={item.label?.toLowerCase() || item.value}
        >
          {item.icon && <item.icon sx={{ mr: 1 }} />}
          {item.label || item.value}
        </ToggleButton>
      ))}
    </StyledToggleButtonGroup>
  );
};

export default ToggleGroup;
